import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ShamArrowLineRightIcon } from 'sham-components/icons';
import { LanguageService } from 'sham-components/services';

@Component({
  selector: 'app-home-cards-list',
  imports: [RouterLink, ShamArrowLineRightIcon, TranslateModule],
  templateUrl: './home-cards-list.html',
  styleUrl: './home-cards-list.css',
})
export class HomeCardsList {
  public title = input.required<string>();
  public listLink = input.required<string>();
  lang = inject(LanguageService);
}
